import { render, staticRenderFns } from "./TabsBar.vue?vue&type=template&id=9ccbde34&scoped=true"
import script from "./TabsBar.vue?vue&type=script&lang=js"
export * from "./TabsBar.vue?vue&type=script&lang=js"
import style0 from "./TabsBar.vue?vue&type=style&index=0&id=9ccbde34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ccbde34",
  null
  
)

export default component.exports